import { setLocation } from 'utils/wrappers';
import { showErrorWithSupportLink } from 'utils/messages';

import Base from 'app/views/base';

export default Base.extend({
  downloadReport() {
    function downloadReportError() {
      showErrorWithSupportLink('An error occurred while downloading your report.');
    }
    this.model.fetch({
      success(model) {
        const url = model.get('url');
        if (!url) {
          downloadReportError();
          return;
        }
        setLocation(url);
      },
      error() {
        downloadReportError();
      },
    });
  },
});



// WEBPACK FOOTER //
// ./app/views/report_detail_view_base.js